export class PrintInvoiceConstants {
  public static readonly PRINT_INVOICE = 'print-invoice'
}
